const BlockchainAddressFragment = `
    id
    address
    chain
`

export default BlockchainAddressFragment
